module.exports = __webpack_public_path__ + "img/yangli.216a6cfa.jpg";